import PropTypes from 'prop-types';

export const PeriodPropTypes = PropTypes.shape({
  name: PropTypes.string.isRequired,
  taxYear: PropTypes.string.isRequired,
});

export const PeriodsPropTypes = PropTypes.arrayOf(PeriodPropTypes);

export const ModalPropTypes = PropTypes.shape({
  show: PropTypes.bool.isRequired,
});

export const ActionsPropTypes = PropTypes.shape({
  showModalForAddEdit: PropTypes.func.isRequired,
  hideModalForAddEdit: PropTypes.func.isRequired,
  showModalForRemove: PropTypes.func.isRequired,
  hideModalForRemove: PropTypes.func.isRequired,
  fetchEntities: PropTypes.func,
  saveEntity: PropTypes.func,
  removeEntity: PropTypes.func,
  uploadEntitiesFromFile: PropTypes.func,
  importEntities: PropTypes.func,
});
